// iOS (all browsers, since every iOS browser is WebKit under the hood) never
// implements the Screen Capture API — navigator.mediaDevices.getDisplayMedia
// is simply absent, permanently, not something that starts working on retry.
// Desktop Safari has the API but is stricter about it and can throw/reject in
// ways Chrome doesn't. Callers use this to skip a mandatory screen-share step
// instead of showing candidates on those devices an unwinnable "required" gate.
export function isScreenShareSupported(nav = (typeof navigator !== "undefined" ? navigator : undefined)) {
  return !!(nav && nav.mediaDevices && typeof nav.mediaDevices.getDisplayMedia === "function");
}
